import { Grid, GridColumn as Column, GridDetailRowProps } from '@progress/kendo-react-grid';
import { Loader } from '@progress/kendo-react-indicators';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchApi } from 'services/api';

type OnboardedVertical = {
  IndustryVerticalId: number;
};

type SalespersonVerticalSummary = {
  SalespersonID: number;
  Name: string;
  YTDOnboardedAccounts: number;
  YTDActiveAccounts: number;
  YTDTotalRevenue: number;
  YTDConversionRate?: number | null;
  CurQOnboardedAccounts: number;
  CurQActiveAccounts: number;
  CurQTotalRevenue: number;
  CurQConversionRate?: number | null;
};

type Response = {
  Salespeople: SalespersonVerticalSummary[];
};

const CorporateSalesDashboardVerticalDetail = ({ dataItem }: GridDetailRowProps) => {
  const vertical = dataItem as OnboardedVertical;
  const [loading, setLoading] = useState(true);
  const [salespeople, setSalespeople] = useState<SalespersonVerticalSummary[]>([]);

  useEffect(() => {
    setLoading(true);
    fetchApi(`/api/Customer/CorporateSalesDashboardVerticalDetail/${vertical.IndustryVerticalId}`)
      .then((response: Response) => setSalespeople(response.Salespeople))
      .catch(() => alert('Unable to load onboarded salesperson details.'))
      .finally(() => setLoading(false));
  }, [vertical.IndustryVerticalId]);

  if (loading) return <Loader type="pulsing" size="small" />;
  if (!salespeople.length) return <div className="k-text-center">No onboarded accounts found for this vertical.</div>;

  return (
    <Grid data={salespeople} dataItemKey="SalespersonID">
      <Column
        field="Name"
        title="Salesperson"
        cells={{
          data: (props) => <td {...props.tdProps}>
            <Link style={{ color: '#007bff' }} to={`/SalesReports/${props.dataItem.SalespersonID}`}>{props.dataItem.Name}</Link>
          </td>
        }}
      />
      <Column field="YTDOnboardedAccounts" title="YTD Onboarded" />
      <Column field="YTDActiveAccounts" title="YTD Active" />
      <Column field="YTDTotalRevenue" title="YTD Revenue" format="{0:c}" />
      <Column field="YTDConversionRate" title="YTD Conversion" format="{0:p0}" />
      <Column field="CurQOnboardedAccounts" title="Q Onboarded" />
      <Column field="CurQActiveAccounts" title="Q Active" />
      <Column field="CurQTotalRevenue" title="Q Revenue" format="{0:c}" />
      <Column field="CurQConversionRate" title="Q Conversion" format="{0:p0}" />
    </Grid>
  );
};

export default CorporateSalesDashboardVerticalDetail;
